import React from 'react';
import * as data from '../../data/events'
import './events.scss'
import EventFilterButtons from './eventFilterButtons'
import EventList from './eventList'
import EventSidebar from './eventSidebar'
import Header from '../header'

class EventsTimeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      events: [],
      filter: 'all',
    };

    this.onFilter = this.onFilter.bind(this);
  }

  componentDidMount() {
    const { events } = data;
    this.setState({ events });
  }

  // onEventsLinkClick(e, link) {
  //   e.preventDefault();
  //   localStorage.setItem('section', link);
  //   setTimeout(() => {
  //     window.location = '/';
  //   }, 200);
  // }

  onFilter(e, newFilter) {
    e.preventDefault();
    const { filter } = this.state;

    newFilter === filter
      ? this.setState({ filter: 'all' })
      : this.setState({ filter: newFilter });
  }

  render() {
    const { events, filter } = this.state;

    let activeEvents;

    // const filters = [
    //   'volunteer_work',
    //   'awards',
    //   'community_outreach',
    //   'dignitary_meetings',
    //   'keynote_speech',
    //   'interviews',
    // ];

    let titleText = filter.replace('_', ' ');

    switch(filter) {
      case 'all':
        activeEvents = events;
        break;
      case 'keynote_speech':
        activeEvents = events.filter(e => e[filter] === true);
        titleText = 'Keynote Speeches';
        break;
      default:
        activeEvents = events.filter(e => e[filter] === true)
        break;
    }

    return (
      <div>
        <Header />
        <div className="page-content page-events">
          <h2 className="page-events-title">
            Carter's
            <span className="capitalize">{ filter !== 'all' ? ` ${titleText} ` : ' Events '}</span>
            ({activeEvents.length})
          </h2>
          <EventFilterButtons onFilter={this.onFilter} filter={filter} />
          <EventList
            events={activeEvents}
          />
        </div>
      </div>
    );
  }
}

export default EventsTimeline;
